function trimAndLower(id: string | null) {
    return id != null ? id.trim().toLowerCase() : id;
}

export default trimAndLower;
